import React, { useState } from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import { filterButtons } from './config';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { fetchProjectList } from 'src/redux/actions';
import ProjectCard from './Components/ProjectCard';
import Spinner from 'src/Components/Spinner';
import Button_V2 from 'src/Components/Button_V2';
import { DEFAULT_LIMIT_ITEM } from './constants';
import ErrorViewV2 from 'src/Components/ErrorViewV2';
import { formatErrorMessage } from 'src/Pages/Staking/utils';
import { ErrorViewType } from 'src/Components/ErrorViewV2/config';
import PageContent from 'src/Components/PageContent';
import { AppError } from 'src/redux/types';

const UpcomingProject = () => {
  var _data, _filterButtons$find;

  const dispatch = useTypedDispatch();
  const [currentStatus, setCurrentStatus] = useState();
  const [projectList, setProjectList] = useState([]);
  const [changingStatus, setChangingStatus] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const signedIn = useTypedSelector(state => !!state.userProfile.user);
  const {
    loading,
    error,
    data,
    invalidated
  } = useTypedSelector(state => state.projectList);
  const cursor = (_data = data[data.length - 1]) === null || _data === void 0 ? void 0 : _data.id;

  const fetchData = async ({
    cursor,
    projectStatus,
    allowlistStatus
  }) => {
    await dispatch(fetchProjectList({
      limit: DEFAULT_LIMIT_ITEM,
      cursor,
      projectStatus,
      allowlistStatus
    }));
    setChangingStatus(false);
  };

  React.useEffect(() => {
    fetchData({
      projectStatus: currentStatus
    });
  }, []);
  React.useEffect(() => {
    if (data.length) {
      setProjectList(projectList.concat(data));

      if (data.length < DEFAULT_LIMIT_ITEM) {
        setShowButton(false);
      } else {
        setShowButton(true);
      }
    } else {
      setShowButton(false);
    }
  }, [data]);
  React.useEffect(() => {
    setProjectList([]);
  }, [currentStatus]);

  const onShowMore = () => {
    fetchData({
      cursor,
      projectStatus: currentStatus
    });
  };

  const onFilter = projectStatus => {
    if (currentStatus !== projectStatus) {
      setCurrentStatus(projectStatus);
      setChangingStatus(true);
      fetchData({
        projectStatus
      });
    }
  };

  const renderMenu = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.menu
    }, filterButtons.map(({
      label,
      projectStatus
    }) => /*#__PURE__*/React.createElement(Button_V2, {
      disabled: projectStatus === 'my-list' && !signedIn,
      key: label,
      className: classnames(styles.menuItem, projectStatus === currentStatus && styles.active),
      onClick: () => {
        onFilter(projectStatus);
      },
      title: label
    })));
  };

  const renderError = () => {
    return /*#__PURE__*/React.createElement(ErrorViewV2, {
      config: {
        content: formatErrorMessage(error),
        title: 'OOPS!',
        type: ErrorViewType.Custom
      },
      className: styles.error
    });
  };

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(Spinner, {
      className: styles.spinner
    });
  };

  const renderContent = () => {
    return /*#__PURE__*/React.createElement("div", null, !!projectList.length && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles.list
    }, projectList.map(project => /*#__PURE__*/React.createElement(ProjectCard, {
      project: project,
      key: project.id
    }))), showButton && /*#__PURE__*/React.createElement("div", {
      className: styles.buttonContainer
    }, /*#__PURE__*/React.createElement(Button_V2, {
      loading: loading,
      className: styles.button,
      title: "Show more",
      type: "outlined",
      onClick: onShowMore
    }))), !projectList.length && /*#__PURE__*/React.createElement("div", {
      className: styles.empty
    }, /*#__PURE__*/React.createElement("span", null, "No Launches yet")));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, (_filterButtons$find = filterButtons.find(item => item.projectStatus === currentStatus)) === null || _filterButtons$find === void 0 ? void 0 : _filterButtons$find.label, "\xA0Projects")), renderMenu(), /*#__PURE__*/React.createElement(PageContent, {
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError,
    error: error !== AppError.NO_ERROR,
    loading: changingStatus,
    invalidated: changingStatus ? invalidated : false // We only want to show the renderLoading when switching status, and keep the screen stays still when load more projects with the same status, to avoid the "jumping" effect of the block

  })));
};

export default UpcomingProject;